export enum Routes {
  AccountingRouter = '/accounting/*',
  LedgersPage = 'ledgers',
  AccountingSettingsPage = 'settings',
  ClassesPage = 'classes',
  InvoicesPage = 'invoices',
}
